import { Task } from 'taskarian';
import UserGroupMembershipsStore from '..';
import { callApi } from '../../../../../../../../Appy';
import { findLinkT } from '../../../../../../../../LinkyLinky';
import { Link } from '../../../../../../../../Resource/Types';
import { fromNullableT } from '../../../../../../../../TaskExt';
import { userGroupMembershipsNewFormResourceDecoder } from '../Decoders';
import { UserGroupMembershipsError, UserGroupMembershipsNewFormResource } from '../Types';

const loadNewUserGroupMembershipsResource = (links: ReadonlyArray<Link>) =>
  Task.succeed<UserGroupMembershipsError, ReadonlyArray<Link>>(links)
    .andThen(findLinkT('new-user-group-memberships'))
    .andThen(callApi(userGroupMembershipsNewFormResourceDecoder, {}));

const loadNewTemplate = (args: { resource: UserGroupMembershipsNewFormResource }) =>
  fromNullableT(args.resource.templates.self);

export const loadForNew = (links: ReadonlyArray<Link>, store: UserGroupMembershipsStore) =>
  Task.succeed<UserGroupMembershipsError, {}>({})
    .assign('resource', loadNewUserGroupMembershipsResource(links))
    .assign('template', loadNewTemplate)
    .fork(store.loadError, store.ready);
